<!-- EINGELOGGTER USER -->
<mat-sidenav-container *ngIf="user?.email != undefined; else login" class="sidenav-container">
    <mat-sidenav
        #drawer
        class="sidenav"
        fixedInViewport
        role="dialog"
        mode="over"
        fxShow="true"
    >
        <mat-nav-list>
          <div *ngFor="let menuItem of menuItems">
            <a
                class="app-nav-drawer__item"
                mat-list-item

                *ngIf="(menuItem.disabled | async) && !menuItem.disabledOnPhone"
                [routerLink]="menuItem.isRouterLink ? menuItem.href : null"
                [href]="!menuItem.isRouterLink ? menuItem.href : null"
                routerLinkActive="active"
                (click)="drawer.close()"
            >{{ menuItem.text | translate }}</a>
          </div>
        </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>
        <mat-toolbar color="primary" class="hideThis">
            <button
                type="button"
                aria-label="Toggle sidenav"
                mat-icon-button
                (click)="drawer.toggle()"
                [fxShow]="isSmallDevice"
            >
                <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
            </button>
          <a *ngIf="!isSmallDevice" class="toTheRight" href="/myDay/landingpage">
            <img border="0" alt="myDay" src="//local.curion.ch/myDay/assets/Logo_myday1.png" width="50" height="50">
          </a>
            <span class="app-nav-bar__spacer"></span>

            <ng-container *ngIf="!isSmallDevice">
              <div
                *ngFor="let menuItem of menuItems"
              >
                <a
                    class="app-nav-bar__item"
                    mat-flat-button
                    *ngIf="(menuItem.disabled | async)"
                    [routerLink]="menuItem.isRouterLink ? menuItem.href : null"
                    [href]="!menuItem.isRouterLink ? menuItem.href : null"
                    routerLinkActive="active"
                >{{ menuItem.text | translate }}</a>
              </div>
            </ng-container>
            <!-- Versionsnummer -->


          <button  class="app-nav-bar__item kontoButton" [matMenuTriggerFor]="actionMenu">
            <mat-icon style="margin-right: 5px" aria-hidden="false">account_circle</mat-icon>{{user.email}}
          </button>
            <button matTooltip="Einstellungen"  id="settingsButton" class="app-nav-bar__item kontoButton" [matMenuTriggerFor]="settingMenu">
              <mat-icon  style="margin-left: 5px" aria-hidden="false">settings</mat-icon>
            </button>
          <mat-menu #actionMenu="matMenu">
            <mat-form-field (click)="$event.stopPropagation()" appearance="outline" color="accent">
              <mat-label>{{ 'pages.mitarbeiterverwaltung.mitarbeiterDialog.rolle' | translate }}</mat-label>
              <mat-select  (selectionChange)="changeRolle($event.value)" [(value)]="user.rolleId">
                <mat-option *ngFor="let rolle of ($rollen | async)" [value]="rolle.id">
                  {{rolle.key}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <button [disabled]="!(showProfile | async)" *ngIf="($personalien | async) as personalien" mat-menu-item (click)="editPersonalien(personalien)" >{{ 'navbar.meinProfil' | translate }}</button>
            <button [disabled]="!(showFirma | async)" *ngIf="($firma | async) as firma" mat-menu-item (click)="editFirma(firma)" >{{ 'navbar.firmaProfil' | translate }}</button>
            <button (click)="changePasswort(user.email)" mat-menu-item >{{ 'navbar.changePasswort' | translate }}</button>
            <button (click)="logout()" mat-menu-item >{{ 'navbar.logout' | translate }}</button>
          </mat-menu>
            <mat-menu #settingMenu="matMenu">
              <button *ngIf="(showRollenverwaltung | async) && !isSmallDevice" mat-menu-item (click)="openRollenverwaltung()" >{{ 'navbar.rollenverwaltung' | translate}}</button>
              <button *ngIf="!isSmallDevice" mat-menu-item (click)="openSpesenverwaltung()" >{{ 'navbar.spesenverwaltung' | translate}}</button>
              <button mat-menu-item >V 4.8.4 - 05.10.23</button>
            </mat-menu>

          <!--       <ng-container>
                   <a
                     class="app-nav-bar__item"
                     mat-button
                     id="email"
                   >{{user.email}}
                   </a>
                 </ng-container>-->
        </mat-toolbar>
        <ng-content></ng-content>
    </mat-sidenav-content>
</mat-sidenav-container>


<!-- NICHT EINGELOGGTER USER -->

<!-- INSERT CODE VON LOGIN -->
<ng-template class="login" #login>
  <div class="setFooter">
  <mat-toolbar class="loginHeader">
    <a class="curionLogo" href="//www.curion.ch">
      <img class="curionLogo" border="0" alt="curion" src="http://www.curion.ch/wp-content/uploads/2018/04/curion-logo_weiss-1024x192.png" width="65" height="65">
    </a>
    <h1 *ngIf="!isSmallDevice" class="curionTel">{{ 'pages.login.text.telNummer' | translate }}</h1>
  </mat-toolbar>
  <mat-toolbar color="primary">
    <a class="toTheRight" href="/myDay/landingpage">
      <img border="0" alt="myDay" src="//local.curion.ch/myDay/assets/Logo_myday1.png" width="50" height="50">
    </a>
    <div class="toTheRight">{{ 'pages.login.title' | translate }}</div>
  </mat-toolbar>

  <div class="loginPage">

    <div class="loginEingabe">
      <div>
        <form [formGroup]="loginForm" autocomplete=off>

          <mat-form-field appearance="outline" color="accent">
            <mat-label>{{ 'pages.login.loginDialog.email' | translate }}</mat-label>
            <input
              autocomplete="email"
              matInput
              [placeholder]="'pages.login.loginDialog.email' | translate"
              formControlName="email"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" color="accent">
            <mat-label>{{ 'pages.login.loginDialog.passwort' | translate }}</mat-label>
            <input
              type="password"
              matInput
              [placeholder]="'pages.login.loginDialog.passwort' | translate"
              formControlName="passwort"
              (keydown.enter)="checkLogin(loginForm.value.email, loginForm.value.passwort)"
            />
          </mat-form-field>

        </form>
      </div>
      <button
        *ngIf="isSmallDevice"
        class="loginButtons"
        mat-raised-button
        color="accent"
        (click)="checkLogin(loginForm.value.email, loginForm.value.passwort)"
        [disabled]="loginForm.invalid"
      >
        {{ 'pages.login.loginDialog.submitButtonLabel' | translate }}
      </button>

      <button
        *ngIf="isSmallDevice"
        class="loginButtons"
        mat-raised-button
        color="accent"
        (click)="resetPasswort()"
      >
        {{ 'pages.login.resetPasswort' | translate }}
      </button>
      <div *ngIf="!isSmallDevice" class="eineLinie">
        <button
          class="loginButtons"
          mat-raised-button
          color="accent"
          (click)="checkLogin(loginForm.value.email, loginForm.value.passwort)"
          [disabled]="loginForm.invalid"
        >
          {{ 'pages.login.loginDialog.submitButtonLabel' | translate }}
        </button>

        <button
          class="loginButtons"
          mat-raised-button
          color="accent"
          (click)="resetPasswort()"
        >
          {{ 'pages.login.resetPasswort' | translate }}
        </button>
      </div>
        <p class="errorMessage" *ngIf="showHint">E-Mail oder Passwort falsch</p>

    </div>

    <div *ngIf="!isSmallDevice" class="myDayLogo">
      <img class="centeredLogo" border="0" alt="myDay" src="//local.curion.ch/myDay/assets/Logo_myday1.png">
    </div>

  </div>
  <mat-toolbar *ngIf="!isSmallDevice" class="footer2" color="primary">
    <div class="myDayBeschreibung">
      <h1 class="lineBreak">{{ 'pages.login.text.beschreibung' | translate }}</h1>
      <img  border="0" alt="curion" src="http://www.curion.ch/wp-content/uploads/2021/01/querstrich-lang-1024x10.png" width="716.8" height="7">
    </div>

    <div class="myDayFunktionen">
      <div class="myDayElemente">
      <img  border="0" alt="curion" src="http://www.curion.ch/wp-content/uploads/2021/01/Icone-Personen-Adressen150.png" width="120" height="128">
        <h1 class="titelAbstand" >{{ 'pages.login.text.personal.title' | translate }}</h1>
        <p class="lineBreak">{{ 'pages.login.text.personal.text' | translate }}</p>
      </div>
      <div class="myDayElemente">
      <img  border="0" alt="curion" src="http://www.curion.ch/wp-content/uploads/2021/01/Icone-Projekte150.png" width="120" height="128">
        <h1 class="titelAbstand">{{ 'pages.login.text.projekte.title' | translate }}</h1>
        <p class="lineBreak">{{ 'pages.login.text.projekte.text' | translate }}
        </p>
      </div>
      <div class="myDayElemente">
      <img  border="0" alt="curion" src="http://www.curion.ch/wp-content/uploads/2021/01/Icone-Zeiterfassung150.png" width="120" height="128">
        <h1 class="titelAbstand">{{ 'pages.login.text.zeiterfassung.title' | translate }}</h1>
        <p class="lineBreak">{{ 'pages.login.text.zeiterfassung.text' | translate }}
        </p>
      </div>
      <div>
      </div>

    </div>
  </mat-toolbar>
  </div>
  <mat-toolbar class="footer" color="accent">
    <p *ngIf="!isSmallDevice" style="text-align: left;">{{ 'pages.login.text.poweredby' | translate }}
      <a class="curionLogo" href="//www.curion.ch">
    <img class="curionLogo" border="0" alt="curion" src="./assets/curion%20logo%20rgb_transparent_700pix.png" width="65" height="65">
      </a>
    </p>

      <p  class="lineBreak">{{ 'pages.login.text.adresse' | translate }}
      </p>
    <p class="lineBreak">
      {{ 'pages.login.text.telEmail' | translate }}
    </p>
    <p  *ngIf="!isSmallDevice" class="lineBreak">
      {{ 'pages.login.text.websiteCurion' | translate }}
    </p>
  </mat-toolbar>
</ng-template>
